import styles from './textarea.module.scss';
import { Flex, Input } from 'antd';
import { TextAreaProps as AntTextAreaProps } from 'antd/es/input';
import { TextAreaStatus } from './textarea.types';
import Label from '../label/label';
import clsx from 'clsx';
import { Message } from '../message/message';

const { TextArea: AntTextArea } = Input;

interface TextAreaProps extends Omit<AntTextAreaProps, 'status'> {
  label?: string;
  message?: string;
  status?: TextAreaStatus;
  containerClass?: string;
}

export function TextArea({ status, label, message, containerClass, ...props }: TextAreaProps) {
  const { disabled } = props;

  return (
    <Flex className={clsx(styles.textAreaContainer, containerClass)} gap={6} vertical>
      {label && <Label isDisabled={disabled} status={status} text={label} />}
      <AntTextArea
        {...props}
        className={clsx(
          styles.textArea,
          disabled && styles['textArea-disabled'],
          status && styles[`textArea-${status}`],
          props.className
        )}
      />
      {message && (
        <Message className={styles.message} isDisabled={disabled} status={status} text={message} />
      )}
    </Flex>
  );
}
